import { roundBalance } from '../../common/tools';
import config from '../../common/const';
import { info } from '../broadcast';
import { observer as globalObserver } from '../../../common/utils/observer';

export default Engine =>
    class Balance extends Engine {
        initialBalance = undefined;
        observeBalance() {
            this.listen('balance', r => {
                const {
                    balance: { balance: b, currency },
                } = r;
                if (!this.initialBalance) {
                    this.initialBalance = b;
                }

                // Some API endpoints (e.g. v4 OTP) return a balance event where
                // r.balance.balance is undefined. Fall back to the value already in
                // globalObserver (set by View.js's independent standard-Deriv connection).
                if (b == null || Number.isNaN(Number(b))) {
                    const fallbackBalance = globalObserver.getState('balance');
                    const fallbackCurrency = globalObserver.getState('currency') || currency;
                    if (fallbackBalance != null && !Number.isNaN(Number(fallbackBalance)) && fallbackCurrency) {
                        const rounded = roundBalance({ currency: fallbackCurrency, balance: fallbackBalance });
                        info({ accountID: this.accountInfo?.loginid, balance: `${rounded} ${fallbackCurrency}` });
                    }
                    return;
                }

                const balance = roundBalance({
                    currency,
                    balance: config.debug ? b - (this.initialBalance - config.balance) : b,
                });

                if (balance === 'NaN' || Number.isNaN(Number(balance))) return;

                const balanceStr = `${balance} ${currency}`;

                globalObserver.setState({ balance, currency });

                info({ accountID: this.accountInfo?.loginid, balance: balanceStr });
            });
        }
        // eslint-disable-next-line class-methods-use-this
        getBalance(type) {
            const balance = globalObserver.getState('balance');
            const balanceStr = `${balance}`;
            return type === 'STR' ? balanceStr : Number(balance);
        }
    };
